// utils/SocketProvider.js
import { createContext, useContext, useEffect, useRef } from "react";
import io from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

const SocketContext = createContext();
export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const socketRef = useRef(null);

    useEffect(() => {
        socketRef.current = io(SOCKET_URL, {
            transports: ['polling', 'websocket'],
            withCredentials: true,
        });

        socketRef.current.on("connect", () => {
            console.log(`✅ Socket connected: ${socketRef.current.id}`);
        });

        socketRef.current.on("disconnect", () => {
            console.log("❌ Socket disconnected");
        });

        socketRef.current.on("connect_error", (error) => {
            console.log(error);
            console.error(`🔴 Socket connection error: ${error.message}`);
        });

        return () => {
            socketRef.current.disconnect();
        };
    }, []);

    return (
        <SocketContext.Provider value={socketRef}>
            {children}
        </SocketContext.Provider>
    );
};